
const download = () => (
    <svg width="22" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 17.3v2.4a2.5 2.5 0 0 0 2.5 2.6h15a2.5 2.5 0 0 0 2.5-2.6v-2.4M4.8 9.8 11 16l6.3-6.3M11 1v15" stroke="#941E3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default download;